var exports = {
  "kL": "AudioPlayer.module__container___UzRPNH",
  "Md": "AudioPlayer.module__fileName___UzRPNH",
  "NE": "AudioPlayer.module__progressSection___UzRPNH",
  "hr": "AudioPlayer.module__progressBar___UzRPNH",
  "Ey": "AudioPlayer.module__timeDisplay___UzRPNH",
  "ne": "AudioPlayer.module__controls___UzRPNH",
  "gm": "AudioPlayer.module__mainControls___UzRPNH",
  "Rr": "AudioPlayer.module__playButton___UzRPNH",
  "$3": "AudioPlayer.module__seekButton___UzRPNH",
  "f6": "AudioPlayer.module__secondaryControls___UzRPNH",
  "Wq": "AudioPlayer.module__volumeControl___UzRPNH",
  "Sn": "AudioPlayer.module__playbackRate___UzRPNH",
  "M0": "AudioPlayer.module__bar___UzRPNH",
  "Hw": "AudioPlayer.module__mobile___UzRPNH",
};

module.exports = exports;
